import React from 'react';
import { MenuItem } from '../../../shared/types/menu';

import { Container, Item } from '../../../../DropdownLinkGrid';

export interface Props {
  items: MenuItem[];
  itemHandleOnClick: (MenuItem) => void;
}

const AccountDropdown = ({ items, itemHandleOnClick }: Props) => {
  const sortedItems = [
    items[1],
    items[0],
    items[2],
    items[3],
    items[5],
    items[7],
    items[6],
    items[8],
  ];

  return (
    <Container className="account-dropdown">
      {sortedItems.map((item) => (
        <Item
          key={item?.title}
          item={item}
          handleOnClick={itemHandleOnClick}
          className={item?.title.replace(' ', '').toLowerCase()}
          testId={`navbar-menu-myaccount-submenu-${item?.title.toLowerCase()}`}
        />
      ))}
    </Container>
  );
};

export default AccountDropdown;
